import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import { removeUnsetHeaders } from 'chessboard/api/model/remove-unset-headers';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Create the setGameDetails method.
 */
export function createSetGameDetails(context: API.Context) {
  /**
   * Set the game details (saves to PGN, which is the source of truth).
   */
  return function setGameDetails(details: Partial<JCE.PGNHeaders>): API.Response {
    const { game, respond } = context;

    const data = removeUnsetHeaders(game.header(details));

    return respond(Core.APIEvents.UpdatePGNHeaders, data);
  };
}
